import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Alarm } from '@app/models/alarm';
import { environment } from '@environments/environment';

const API = environment.API;

@Injectable({
  providedIn: 'root'
})
export class AlarmService {
  constructor(private http: HttpClient) {}

  get(data: any) {
    return this.http.get<Alarm[]>(`${API}alarms?FollowId=${data.FollowId}`);
  }

  create(alarm: Alarm) {
    return this.http.post<Alarm>(`${API}alarms`, alarm);
  }

  update(id, alarm) {
    return this.http.put<Alarm>(`${API}alarms/${id}`, alarm);
  }

  delete(alarmId){
    return this.http.delete<Alarm>(`${API}alarms/${alarmId}`,);
  }
}
